<!-- eslint-disable vue/max-len -->
<template>
  <svg
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 3.73333C0 1.67147 1.6531 0 3.69231 0H20.3077C22.3469 0 24 1.67147 24 3.73333V20.3C24 20.3395 23.9976 20.3784 23.9928 20.4167C23.9976 20.4549 24 20.4938 24 20.5333C24 21.0488 23.5867 21.4667 23.0769 21.4667C23.0413 21.4667 22.8287 21.5006 22.573 21.9532C22.3321 22.3793 22.1538 23.0303 22.1538 23.8C22.1538 24.5697 22.3321 25.2207 22.573 25.6468C22.8287 26.0994 23.0413 26.1333 23.0769 26.1333C23.5867 26.1333 24 26.5512 24 27.0667C24 27.5821 23.5867 28 23.0769 28H4.15385C1.85972 28 0 26.1196 0 23.8V3.73333ZM4.15385 26.1333C2.87935 26.1333 1.84615 25.0887 1.84615 23.8C1.84615 22.5113 2.87935 21.4667 4.15385 21.4667H20.7538C20.4641 22.1467 20.3077 22.9561 20.3077 23.8C20.3077 24.6439 20.4641 25.4533 20.7538 26.1333H4.15385ZM15.492 8.51396C15.8091 8.11039 15.7426 7.52327 15.3435 7.20258C14.9443 6.88193 14.3637 6.94913 14.0465 7.35271L11.0832 11.1235L9.95349 9.68599C9.63632 9.28242 9.05566 9.21522 8.65652 9.53591C8.25739 9.85661 8.19092 10.4437 8.50805 10.8473L10.3417 13.1806C10.5279 13.4175 10.8049 13.5385 11.0827 13.5332C11.3608 13.5388 11.6382 13.4178 11.8246 13.1806L15.492 8.51396Z"
      fill="currentColor"
    />
  </svg>
</template>
